assert.notEqual = notEqual;
assert.notOk = notOk;
assert.equal = equal;
assert.ok = assert;
module.exports = assert;
function equal(a, b, m) {
    assert(a == b, m); // eslint-disable-line eqeqeq
}
function notEqual(a, b, m) {
    assert(a != b, m); // eslint-disable-line eqeqeq
}
function notOk(t, m) {
    assert(!t, m);
}
function assert(t, m) {
    if (!t)
        throw new Error(m || 'AssertionError');
}
